'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMSubmitButton = require('./OMSubmitButton.scss');var styles = _interopRequireWildcard(_OMSubmitButton);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getHandlers = function getHandlers(_ref) {var onClick = _ref.onClick,disableSubmit = _ref.disableSubmit;return disableSubmit && onClick ?
  { onClick: onClick } :
  {};};


var OMSubmitButton = function OMSubmitButton(properties) {return (
    _react2.default.createElement('button', _extends({
        type: properties.disableSubmit ? 'button' : 'submit',
        className: (0, _classnames2.default)(styles.submitBtn, properties.className),
        disabled: properties.disabled },
      getHandlers(properties)),

      properties.activeSpinner ?
      _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
      _react2.default.createElement('span', { className: 'button-text' }, properties.title)));};exports.default =




OMSubmitButton;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMSubmitButton/OMSubmitButton.js
// module id = 1221
// module chunks = 0